import Velocity from 'velocity-animate';

function getOffset(box) {
  const box_position = box.getBoundingClientRect();

  const screen_width = document.body.clientWidth;
  const screen_height = document.body.clientHeight;

  const x = screen_width / 2 - (screen_width - box_position.x - box_position.width / 2);
  const y = screen_height / 2 - (screen_height - box_position.y) + box_position.height * 2;

  return { x, y };
}

export function from_element($el) {
  return {
    enter: function(modal_wrapper, modal_content, done) {
      const offset = getOffset($el, modal_content);

      Velocity(
        modal_content,
        {
          translateX: `${offset.x}px`,
          translateY: `${offset.y}px`,
          scale: 0.2,
          opacity: 1
        },
        {
          duration: 0,
          complete: e => {
            Velocity(
              e,
              {
                opacity: 1,
                scale: 1,
                translateX: `0px`,
                translateY: `0px`
              },
              {
                duration: 280,
                complete: done
              }
            );
          }
        }
      );
    },

    leave: function(modal_wrapper, modal_content, done) {
      const offset = getOffset($el, modal_content);
      Velocity(
        modal_content,
        {
          translateX: `${offset.x}px`,
          translateY: `${offset.y}px`,
          scale: 0.2,
          opacity: 0
        },
        { duration: 280, complete: done }
      );
    }
  };
}
